import { get } from '../../../../shared/ajax-helpers'
import selectionRange from 'selection-range'
import closest from 'closest'
import SirTrevor from 'sir-trevor';

const listTemplate = `
  <div class="st-userlist">
    <h4 class="st-userlist-heading">Suggestions</h4>
    <ul class="st-userlist__items"></ul>
  </div>
`;

const userTemplate = (data) => `
  <li class="st-userlist-item st-userlist-user" data-name="${data.name}" data-slug="${data.slug}" data-id="${data.id}">
    <span class="st-userlist-item__name">${data.name}</span>
    <span class="st-userlist-item__secondary">${data.job_title || ''}</span>
  </li>
`;

const atKeyCode = 64;

export default {

  initializeMentions: function() {

    if (this.initializedMentions) { return; }

    this.initializedMentions = true;
    this.mentioning = false;
    this.savedMentions = {};
    this.selectedMentionIndex = 0;

    this.form = SirTrevor.getInstance(this.instanceID).form;

    let mentionsElement = this.form.querySelector('.js-sir-trevor-mentions');
    if (mentionsElement) {
      this.savedMentions = JSON.parse(mentionsElement.value);
      this.loadedMentions = true;
    }

    let list = document.createElement('div');
    list.innerHTML = listTemplate;
    document.body.appendChild(list);
    this.mentionList = list.querySelector('.st-userlist');
    this.mentionListHeading = list.querySelector('.st-userlist-heading');
    this.hideMentionList();

    this.mentionListItems = this.mentionList.querySelector('.st-userlist__items');

    $(this.mentionListItems).on('click', '.st-userlist-user', this.onMentionClick.bind(this));
  },

  startMentioning: function() {
    this.supressKeyListeners = true;
    // Hide other mention areas.
    Array.from(document.querySelectorAll('.st-userlist'), el => {
      el.style.display = 'none';
    });

    this.mentioning = true;
    this.mentionUsers = [];
    this.node = null;
  },

  updateMentioning: function() {

    let sel = window.getSelection();
    let range = sel.getRangeAt(0);
    let clonedRange = range.cloneRange();

    if (!this.node) {

      this.node = sel.focusNode;
      this.startOffset = sel.focusOffset;

      // If the @ symbol is linked to a text node then don't start mentioning.
      if (this.startOffset > 1) {
        let atRange = range.cloneRange();
        atRange.setStart(this.node, this.startOffset - 2);
        if (atRange.toString().replace(/\s+/g, ' ') !== ' @') {
          this.stopMentioning();
          return;
        }
      }
    }

    this.node = sel.focusNode;
    this.endOffset = sel.focusOffset;

    // Stop when deleting the @ symbol.
    if(this.endOffset < this.startOffset) {
      this.stopMentioning();
      return;
    }

    // TODO
    // Bug in Chrome < 49 means we need to always have non collapsed range.
    // https://bugs.chromium.org/p/chromium/issues/detail?id=574363
    // range.setStart(this.node, this.startOffset);

    clonedRange.setStart(this.node, this.startOffset - 1);
    clonedRange.setEnd(this.node, this.endOffset);

    let rangeBoundingRect = clonedRange.getBoundingClientRect();
    let nodeBoundingRect = clonedRange.startContainer.parentNode.getBoundingClientRect();

    // TODO: Remove in future when chrome 50 is common.
    clonedRange.setStart(this.node, this.startOffset);

    let left = rangeBoundingRect.left;
    let minWidth = 240;

    if (left + minWidth > nodeBoundingRect.right) {
      left = nodeBoundingRect.right - minWidth;
    }

    if (document.body.clientWidth < 480) {
      left = nodeBoundingRect.left;
    }

    let maxWidth = nodeBoundingRect.right - nodeBoundingRect.left;
    if (maxWidth < minWidth) {
      maxWidth = minWidth;
      left = nodeBoundingRect.left;
    }

    let scrollTop = (document.documentElement && document.documentElement.scrollTop) || window.scrollY || document.body.scrollTop || 0;

    this.mentionList.style.top = `${scrollTop + rangeBoundingRect.bottom + 10}px`;
    this.mentionList.style.left = `${left}px`;
    this.mentionList.style.minWidth = `${minWidth}px`;
    this.mentionList.style.maxWidth = `${maxWidth}px`;

    let text = clonedRange.toString().replace(/\s+/g, ' ');

    // If there's more than 1 space in the name and only 1 result then finish the mention
    if (text.slice(-1) && (text.match(/ /g) || []).length > 1) {
      if (this.mentionUsers.length == 1) {
        this.renderMentionTag(this.mentionUsers[0]);
      }
      this.stopMentioning();
      return;
    }

    // If no text is found then not mentioning
    if (text.length > 0) {
      this.getMentionList(text);
    } else {
      this.populateMentionList(text);
    }
  },

  detectMentionStart(e) {
    if (e.keyCode == atKeyCode || e.charCode == atKeyCode) {
      this.startMentioning();
    }
  },

  onMentionKeyDown: function(e) {
    if (this.mentioning) {
      // down arrow
      if (e.keyCode === 40) {
        e.preventDefault();
        e.stopPropagation();
        if (this.selectedMentionIndex + 1 < this.mentionListItems.querySelectorAll('.st-userlist-user').length) {
          this.selectedMentionIndex ++;
          this.updateSelectedMention();
        };
      // up arrow
      } else if (e.keyCode === 38) {
        e.preventDefault();
        e.stopPropagation();
        if (this.selectedMentionIndex > 0) {
          this.selectedMentionIndex --;
          this.updateSelectedMention();
        }
      // enter key
      } else if (e.keyCode === 13) {
        e.preventDefault();
        e.stopPropagation();
        if (this.selectedMention) {
          this.renderMentionFromElement(this.selectedMention);
        }
      }
    }
  },

  renderMentionFromElement: function(el) {
    this.renderMentionTag({
      name: el.getAttribute('data-name'),
      slug: el.getAttribute('data-slug'),
      id: el.getAttribute('data-id')
    });

    this.stopMentioning();
  },

  findMentions: function(e) {
    // Store the texteditor for later use.
    this.textEditor = e.target || e.srcElement;

    if (this.mentioning) {
      // don't update mentions on up arrow, down arrow or enter key
      if (e.keyCode === 40 || e.keyCode === 38 || e.keyCode === 13) {
        return;
      }
      // escape key
      if (e.keyCode === 27) {
        this.stopMentioning();
      } else {
        this.updateMentioning();
      }
    }
  },

  updateSelectedMention: function() {
      const newSelectedMention = this.mentionListItems.querySelectorAll('.st-userlist-user')[this.selectedMentionIndex]
      if (this.selectedMention != newSelectedMention) {
        if (this.selectedMention) {
          this.selectedMention.classList.remove('selected');
        }

        if (newSelectedMention) {
          newSelectedMention.classList.add('selected');
        }
      }
      this.selectedMention = newSelectedMention;
  },

  getMentionList: function(text) {
    text = encodeURIComponent(text);
    get(`/profile/mention_search?search_text=${text}`).then(response => {
      return response.json()
    }).then(response => {
      this.populateMentionList(text, response.users);
    });
  },

  populateMentionList: function(text = '', users = []) {
    this.mentionListItems.innerHTML = '';

    let title = '';
    if (text === '') {
      title = 'Start typing to find a user';
    } else if (users.length === 0) {
      title = 'No user could be found';
    }

    if (title !== '') {
      this.mentionListItems.insertAdjacentHTML('beforeend', `
        <li class="st-userlist-item">
          <span class="st-userlist-item__name">${title}</span>
        </li>
      `);
    }

    this.showMentionList();

    this.mentionUsers = users;

    users.forEach(user => {
      this.mentionListItems.insertAdjacentHTML('beforeend', userTemplate(user));
    });

    // re-select the top username found
    this.selectedMentionIndex = 0;
    this.updateSelectedMention();
  },

  showMentionList: function() {
    this.mentionList.style.display = '';
  },

  hideMentionList: function() {
    this.mentionList.style.display = 'none';
  },

  onMentionClick: function(e) {
    let userEl = e.currentTarget;

    this.renderMentionTag({
      name: userEl.getAttribute('data-name'),
      slug: userEl.getAttribute('data-slug'),
      id: userEl.getAttribute('data-id')
    });

    this.stopMentioning();
  },

  stopMentioning: function() {
    this.mentioning = false;
    this.hideMentionList();
    this.supressKeyListeners = false;
  },

  renderMentionTag: function(user) {

    // Refocus text area
    this.textEditor.focus();

    // Capture range of text plus the @symbol
    let range = document.getSelection().getRangeAt(0);
    range.setStart(this.node, this.startOffset - 1);
    range.setEnd(this.node, this.endOffset);

    // Wrap text in dom element
    let n = this.createMentionElement(user);
    range.surroundContents(n);

    // Select inserted node and collapse
    range = document.createRange();
    range.selectNode(n);
    range.collapse(false);

    // Add an additional space to the end
    let el = document.createElement("div");
    el.innerHTML = '&nbsp;';
    let frag = document.createDocumentFragment(), node, lastNode;
    while ( (node = el.firstChild) ) {
        lastNode = frag.appendChild(node);
    }
    range.insertNode(frag);
    range.collapse(false);

    // Update selection to place the caret
    let selection = document.getSelection();
    selection.removeAllRanges();
    selection.addRange(range);
  },

  insertMentions(text) {
    return text.replace(/\[((user):([0-9]+)):([^\]]+)\](?:\(([^\)]+)\))?/gi, (match1, match2, match3, match4, match5, match6) => {
      let matchedMention = this.savedMentions[match2];
      if (!matchedMention) { return match6 || match5; }

      let n = this.createMentionElement(matchedMention);
      return n.outerHTML + "&nbsp;";
    });
  },


  createMentionElement(user) {
    let n = document.createElement("input");
    n.setAttribute('type', 'button');
    n.setAttribute('disabled', 'disabled');
    n.setAttribute('data-slug', user.slug);
    n.setAttribute('data-name', user.name);
    n.setAttribute('data-id', user.id);
    n.setAttribute('value', `@${user.name}`);
    n.classList.add('st-mention');
    n.innerHTML = "&nbsp;"
    return n;
  },

  getTextContentWithMentions(text) {
    let mentionsHTML = document.createElement('div');
    mentionsHTML.innerHTML = text;
    Array.from(mentionsHTML.querySelectorAll('.st-mention'), el => {
      let slug = el.getAttribute('data-slug');
      let name = el.getAttribute('data-name');
      let id = el.getAttribute('data-id');
      el.parentNode.replaceChild(document.createTextNode(`[user:${id}:${slug}](${name})`), el);
    });
    return mentionsHTML.innerHTML;
  },

  insertHTML(html) {
    let sel = window.getSelection();
    let range = sel.getRangeAt(0);

    // An IE11 friendly way to insertHTML into contenteditable
    let el = document.createElement("div");
    el.innerHTML = html;
    let frag = document.createDocumentFragment(), node, lastNode;
    while ( (node = el.firstChild) ) {
      lastNode = frag.appendChild(node);
    }
    range.insertNode(frag);

    // Preserve the selection
    if (lastNode) {
        range = range.cloneRange();
        range.setStartAfter(lastNode);
        range.collapse(true);
        sel.removeAllRanges();
        sel.addRange(range);
    }

    let selectedNode = closest(range.startContainer, '.st-block__editor, .st-text-block', true);

    // Fake the range to force the correct node to be selected.
    selectionRange(selectedNode, selectionRange(selectedNode));

    selectedNode.focus();
  },

  remove: function() {
    this.mentionList.parentNode.removeChild(this.mentionList);
    this.el.parentNode.removeChild(this.el);
  },

  // We don't want formatter showing when mentioning someone.
  getSelectionForFormatter: function() {
    setTimeout(() => {
      var selection = window.getSelection(),
          selectionStr = selection.toString().trim(),
          en = 'formatter:' + ((selectionStr === '' || this.mentioning) ? 'hide' : 'position');
      this.mediator.trigger(en, this);
      SirTrevor.EventBus.trigger(en, this);
    }, 1);
  }

}
